module.exports = __webpack_public_path__ + "static/img/1.313f283.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/1.png
// module id = /Ojf
// module chunks = 0